import React, { useEffect, useState } from 'react';
import { Button, Card, InputNumber, Modal, Table } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { commaSeparatedString } from '../../utils/utils';
import { CheckCircleOutlined, LinkOutlined, LoadingOutlined } from '@ant-design/icons';
import { getLatestLineItems, updateHubspotLineItems } from '../../services/Apis'
import LineItemCompareTable from './HubSpotLineItem';
import HubSpot from '../../utils/hubspot_icon.png';
import { useCurrency } from '../../context/CurrencyContext';
interface DataType {
  key: string;
  service: string;
  core: number;
  discount: number;
  net: number;
}
interface RevenueSummaryProps {
  dataSrc?: DataType[];
  dealId: number;
  setSaveNewPricingVersion: (value: boolean) => void;
  setReloadNavigation: (value: boolean) => void;
  isDealLocked?: boolean;
  enabledFeatureList: string[];
  distinctServiceLines: string[];
  setSendHubspotLineItems: (value: boolean) => void;
  versionId?: number,
  versionName?: string
}
interface LineItem {
  line_item_id?: number | null;
  name: string;
  amount: number;
}
// Define the columns


// Define the data
const data: DataType[] = [
  {
    key: '1',
    service: 'BI',
    core: 0,
    discount: 0,
    net: 0,
  },
  {
    key: '2',
    service: 'Client Mgmt',
    core: 0,
    discount: 0,
    net: 0,
  },
  {
    key: '3',
    service: 'CX',
    core: 0,
    discount: 0,
    net: 0,
  },
  {
    key: '4',
    service: 'Data Science',
    core: 113685,
    discount: -5684,
    net: 108001,
  },
  {
    key: '5',
    service: 'DEE',
    core: 104078,
    discount: -5204,
    net: 98874,
  },
  {
    key: '6',
    service: 'Insourcing',
    core: 225000,
    discount: 0,
    net: 225000,
  },
  {
    key: '7',
    service: 'Solutions',
    core: 0,
    discount: 0,
    net: 0,
  },
  {
    key: '8',
    service: 'Total',
    core: 442763,
    discount: 0,
    net: 431875,
  },
];


// Incomplete Just the Layout have to make it dynamic
const RevenueSummary: React.FC<RevenueSummaryProps> = ({ dataSrc = data, dealId, setSaveNewPricingVersion, setReloadNavigation, isDealLocked = false, enabledFeatureList, distinctServiceLines, setSendHubspotLineItems, versionId, versionName }) => {
  const { dealCurrency, currencySymbol } = useCurrency();
  const [lineItemModalVisible, setLineItemModalVisible] = useState(false);
  const [lineItems, setLineItems] = useState<LineItem[]>([]);
  const [updatedPricingItems, setUpdatedPricingItems] = useState<LineItem[]>(dataSrc.map(item => ({ name: item.service, amount: item.net })));
  const [loader, setLoader] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [dealTotalAmount, setDealTotalAmount] = useState<number>(0);

  const columns: ColumnsType<DataType> = [
    {
      title: 'Service Line',
      dataIndex: 'service',
      key: 'service',
      fixed: 'left',
      className: 'title-column',
    },
    {
      title: 'Gross Revenue',
      dataIndex: 'core',
      key: 'core',
      align: 'right',
      className: 'total-column',
      render: (text: string) => text ? text.toString().includes('%') ? text : `${currencySymbol} ${commaSeparatedString(text)}` : text,
    },
    // {
    //   title: 'contingency (+)',
    //   dataIndex: 'contingency',
    //   key: 'contingency',
    //   align:'right',
    //   render: (text: string) => text ? text.toString().includes('%') ? text : `$ ${commaSeparatedString(text)}` : text,
    // },
    {
      title: 'Adjustments',
      dataIndex: 'discount',
      key: 'discount',
      align: 'right',
      className: 'total-column',
      render: (text: string) => text ? text.toString().includes('%') ? text : `${currencySymbol} ${commaSeparatedString(-1 * Number(text))}` : text,
    },
    {
      title: 'Net Revenue',
      dataIndex: 'net',
      key: 'net',
      align: 'right',
      className: 'total-column',
      render: (text: string) => text ? text.toString().includes('%') ? text : `${currencySymbol} ${commaSeparatedString(text)}` : text,
    }
  ];

  useEffect(() => {
    setUpdatedPricingItems(dataSrc.map(item => ({ name: item.service, amount: item.net })));
  }, [dataSrc]);

  useEffect(() => {
    const fetchData = async () => {
      const result = await getLatestLineItems(dealId);
      if (result.error_status === 401) {
        window.location.reload();
      } else {
        if (result.error) {
          console.error('Error Response Data:', result.error);
          console.error('Error Response Status:', result.error_status);
          setError(result.error);
          setLoader(false);
        } else {
          setDealTotalAmount(result["deal_amount"]);
          setLineItems(JSON.parse(JSON.stringify(result["hubspot_line_items"])));
          const mergeArrays = (lineItemList: any, pricingAppList: any) => {
            // Create a copy of pricingAppList with an added 'line_item_id: null' property for each object
            const mergedArray = pricingAppList.map((item: any) => ({ ...item, line_item_id: null }));

            lineItemList.forEach((item1: any) => {
              // Check if the name from lineItemList exists in the merged array
              const existingItemIndex = mergedArray.findIndex((item2: any) => item2.name === item1.name);

              if (existingItemIndex !== -1) {
                // If name exists, update the line_item_id in the existing object
                mergedArray[existingItemIndex] = { ...mergedArray[existingItemIndex], line_item_id: item1.line_item_id };
              } else {
                // If name does not exist, add the new object from lineItemList
                if (distinctServiceLines.includes(item1.name))
                  item1.amount = 0 // Set the amount to 0 for new items
                mergedArray.push(item1);
              }
            });

            return mergedArray;
          };
          const newUpdatedPricingItems = mergeArrays(result["hubspot_line_items"], updatedPricingItems);
          setUpdatedPricingItems(newUpdatedPricingItems);
          setLoader(false);
          setError(null);
        }
      }
    }

    if (lineItemModalVisible) {
      setLoader(true);
      fetchData();
    };
  }, [lineItemModalVisible]);

  const handleAmountChange = (name: string, amount: number) => {
    setUpdatedPricingItems((prevState: any) => {
      const serviceLineExists = prevState.findIndex((item: any) => item.name === name);
      if (serviceLineExists !== -1) {
        const updatedServiceLineItems = [...prevState];
        updatedServiceLineItems[serviceLineExists].amount = amount;
        return updatedServiceLineItems;
      } else {
        return [...prevState, { name, amount }];
      }
    });
  }

  return (
    <Card
      title="Revenue Summary by Service Line"
      style={{ marginBottom: '16px' }}
      // extra={(
      //   <div style={{ display: 'flex', justifyContent: 'flex-end', width: "100%" }}>
      //     <Button
      //       type="text"
      //       title={isDealLocked ? 'Unlock Deal to Send Line Items to HubSpot' : 'Send Line Items to HubSpot'}
      //       style={{ marginLeft: '10px' }}
      //       onClick={
      //         () => {
      //           setLineItemModalVisible(true);
      //         }
      //       }
      //       disabled={enabledFeatureList.includes('FE_SUBMIT_LINE_ITEMS') ? isDealLocked ? true : dataSrc.length > 0 ? false : true : true}
      //     >
      //       <LinkOutlined />
      //     </Button>
      //   </div>
      // )}
    >
      <Modal
        title={<span><img
          alt="HubSpot Logo"
          style={{
            padding: '0px',
            width: '20px',
            margin: '0 auto'
          }}
          src={HubSpot}
        />  Upload Line items to HubSpot</span>}
        open={lineItemModalVisible}
        onOk={() => {
          setLineItemModalVisible(false);
          if (!error) {
            setSaveNewPricingVersion(true);
            updateHubspotLineItems(dealId, updatedPricingItems, versionId ?? 0, versionName ?? '');
            setReloadNavigation(true);
            setSendHubspotLineItems(true);
          }
        }}
        onCancel={() => {
          setLineItemModalVisible(false);
        }}
        width={'70%'}
      >
        <LoadingOutlined style={{ display: loader ? 'block' : 'none' }} />
        {error && <p className='text-danger'>Error: {error}</p>}
        {!loader && !error &&
          <LineItemCompareTable dataSrc={dataSrc} totalDealAmount={dealTotalAmount} distinctServiceLines={distinctServiceLines} hubspotLineItems={lineItems as LineItem[]} updatedPricingItems={updatedPricingItems} handleAmountChange={handleAmountChange} />
        }
      </Modal>
      <div style={{ width: '100%', overflowY: 'auto' }}>
        <Table
          dataSource={dataSrc}
          columns={columns}
          rowKey="key"
          pagination={false}
          size="small"
          scroll={{ x: '100%' }}
          style={{ marginBottom: '16px' }}
        />
      </div>
    </Card >
  );
};

export default RevenueSummary;
